<template>
  <div class="rightbar" :class="{ 'search-mode': isSearchActive }">
    <div class="rightbar__inner" :class="{ 'p-0': !isUserAuth }">
      <div class="rightbar__panel">
        <div class="rightbar__scroll scroll-box !flex !flex-col !gap-4 h-[86vh]">
          <!-- Moved global search from Header to Rightbar top -->
          <!-- -----comment start------ -->
          <!-- <div class="rightbar__search" v-if="isUserAuth"
            style="margin-left: 7px !important; width: calc(100% - 14px) !important;">
            <BaseField v-model:value="searchText" @input="fetchSearchResults"
              class="sign-in__field rightbar__search-input" :placeholder="'Search'" isSearch isBottomBorderOnFocus />
          </div> -->
          <!-- -----comment end------ -->
          <transition name="fade">
            <div v-if="showProTip"
              class="bg-[var(--header-bg-light)] border border-[var(--border-leftbar-component)] rounded-2xl px-[10px] py-[10px] shadow-sm">
              <div class="pro-tip">
                <div class="flex items-center gap-2 mb-1">
                  <span class="text-xl shrink-0">💡</span>
                  <span class="text-[var(--right-sidebar-protip)] text-xl font-medium">Pro Tip</span>
                </div>
                <button @click="showProTip = false" class="text-gray-400 hover:text-gray-600 transition"
                  aria-label="Close">
                  ✖
                </button>
              </div>
              <p class="text-sm text-[var(--tip-text-color)] leading-relaxed break-words whitespace-normal text-left">
                When you engage respectfully, your Civility Score rises - which allows you to give real feedback to
                other posts.
              </p>
            </div>
          </transition>
          <!-- ----comment start----- -->
          <!-- <div class="rightbar__posts">
            <div v-if="loading" class="pb-4">
              Loading...
            </div>
            <div v-else-if="searchText && noSearchResults" class="pb-4">
              <h5>No results found for "{{ noSearchResults }}"</h5>
            </div>
            <div v-else-if="!searchText && posts.length && !allUsers.length && !allPosts.length"
              class="rightbar__posts-list rightbar__suggested-block">
              <h4
                class="rightbar__title text-left px-4 pt-4 text-foregroundPrimary text-sm mb-3 font-semibold tracking-wide">
                Suggested for you
              </h4> -->
          <!-- Restore SuggestedPost components with correct props -->
          <!-- <div>
            <div v-for="el in posts" :key="el.id" class="suggested-wrapper">
              <SuggestedPost :data="el" :type="'user'" :gap="0" :isAuth="!!userData"></SuggestedPost>
            </div>
          </div> -->

          <!-- <div v-else-if="allUsers.length || allPosts.length || allGroups.length" class="accordion-results"> -->
          <!-- People Accordion -->
          <!-- <div v-if="allUsers.length" class="accordion-section">
                <button class="accordion-header" @click="toggleAccordion('people')">
                  <span>People Results ({{ allUsers.length }})</span>
                  <span class="chevron" :class="{ open: accordion.people }">›</span>
                </button>
                <transition name="fade-slide">
                  <div v-show="accordion.people" class="accordion-body" :ref="el => setAccordionBodyRef('people', el)">
                    <div class="rightbar__posts-list rightbar__suggested-block slim people-list"
                      @scroll="handleUsersScroll">
                      <div v-for="el in displayedUsers" :key="el.id" class="suggested-wrapper">
                        <SuggestedPost :data="el" :type="'user'" :gap="0" :isAuth="!!userData" />
                      </div>
                      <div class="text-center mt-2" v-if="usersLoading">
                        <ProgressSpinner style="width: 34px; height: 34px; margin: 0 auto" strokeWidth="4"
                          fill="transparent" animationDuration="1.2s" aria-label="Loading users" />
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
              Posts Accordion
              <div v-if="allPosts.length" class="accordion-section">
                <button class="accordion-header" @click="toggleAccordion('posts')">
                  <span>Post Results ({{ allPosts.length }})</span>
                  <span class="chevron" :class="{ open: accordion.posts }">›</span>
                </button>
                <transition name="fade-slide">
                  <div v-show="accordion.posts" class="accordion-body" :ref="el => setAccordionBodyRef('posts', el)">
                    <div class="rightbar__posts-list rightbar__suggested-block slim" @scroll="handlePostsScroll">
                      <div v-for="post in displayedPosts" :key="post.id">
                        <CompactPost :post="post" />
                      </div>
                      <div class="text-center mt-2" v-if="postsLoading">
                        <ProgressSpinner style="width: 34px; height: 34px; margin: 0 auto" strokeWidth="4"
                          fill="transparent" animationDuration="1.2s" aria-label="Loading posts" />
                      </div>
                    </div>
                  </div>
                </transition>
              </div> -->
          <!-- Groups Accordion -->
          <!-- <div v-if="allGroups.length" class="accordion-section">
                <button class="accordion-header" @click="toggleAccordion('groups')">
                  <span>Group Results ({{ allGroups.length }})</span>
                  <span class="chevron" :class="{ open: accordion.groups }">›</span>
                </button>
                <transition name="fade-slide">
                  <div v-show="accordion.groups" class="accordion-body" :ref="el => setAccordionBodyRef('groups', el)">
                    <div class="rightbar__posts-list rightbar__suggested-block slim groups-list">
                      <div v-for="group in limitedGroups" :key="group.id" class="suggested-wrapper group-wrapper">
                        <div class="flex items-start w-full gap-2">
                          <div class="flex-shrink-0">
                            <img :src="groupAvatar(group)" alt="group avatar"
                              class="w-10 h-10 rounded-full object-cover group-avatar" />
                          </div>
                          <div class="flex-1 min-w-0">
                            <div class="flex items-center gap-1">
                              <RouterLink :to="'/group/' + group.id" class="group-name-link truncate">{{ group.name }}
                              </RouterLink>
                            </div>
                            <div class="group-username text-xs opacity-70 truncate">
                              <RouterLink :to="'/group/' + group.id" class="hover:underline">@{{ groupHandle(group) }}
                              </RouterLink>
                            </div>
                            <div v-if="group.description" class="group-desc mt-1">{{ formatGroupDesc(group.description)
                            }}</div>
                          </div>
                          <div class="flex-shrink-0 ml-1">
                            <button class="follow-btn" @click.prevent="toggleFollowGroup(group)">
                              <span v-if="followingGroupIds.has(group.channelId || group.id)">Following</span>
                              <span v-else>Follow</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div v-if="allGroups.length > groupPageSize" class="show-more-wrapper">
                        <button class="show-more-btn" @click="showMoreGroups = !showMoreGroups">
                          {{ showMoreGroups ? 'Show less' : 'Show more' }}
                        </button>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <div v-else class="pb-4">
              <h5>No data available</h5>
            </div>
          </div> -->
          <!-- --------comment end-------->
          <!-- Old Suggestion Group code  -->
          <!-- <div v-if="allGroups.length" class="accordion-section">
            <button class="accordion-header" @click="toggleAccordion('groups')">
              <span>Group Results ({{ allGroups.length }})</span>
              <span class="chevron" :class="{ open: accordion.groups }">›</span>
            </button>
            <transition name="fade-slide">
              <div v-show="accordion.groups" class="accordion-body" :ref="el => setAccordionBodyRef('groups', el)">
                <div class="rightbar__posts-list rightbar__suggested-block slim groups-list">
                  <div v-for="group in limitedGroups" :key="group.id" class="suggested-wrapper group-wrapper">
                    <div class="flex items-start w-full gap-2">
                      <div class="flex-shrink-0">
                        <img :src="groupAvatar(group)" alt="group avatar"
                          class="w-10 h-10 rounded-full object-cover group-avatar" />
                      </div>
                      <div class="flex-1 min-w-0">
                        <div class="flex items-center gap-1">
                          <RouterLink :to="'/group/' + group.id" class="group-name-link truncate">{{ group.name }}
                          </RouterLink>
                        </div>
                        <div class="group-username text-xs opacity-70 truncate">
                          <RouterLink :to="'/group/' + group.id" class="hover:underline">@{{ groupHandle(group) }}
                          </RouterLink>
                        </div>
                        <div v-if="group.description" class="group-desc mt-1">{{ formatGroupDesc(group.description)
                        }}</div>
                      </div>
                      <div class="flex-shrink-0 ml-1">
                        <button class="follow-btn" @click.prevent="toggleFollowGroup(group)">
                          <span v-if="followingGroupIds.has(group.channelId || group.id)">Following</span>
                          <span v-else>Follow</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-if="allGroups.length > groupPageSize" class="show-more-wrapper">
                    <button class="show-more-btn" @click="showMoreGroups = !showMoreGroups">
                      {{ showMoreGroups ? 'Show less' : 'Show more' }}
                    </button>
                  </div>
                </div>
              </div>
            </transition>
          </div> -->
          <div
            class="bg-[var(--header-bg-light)] border border-[var(--border-leftbar-component)] rounded-2xl px-[10px] py-[10px] shadow-sm flex flex-col gap-2">
            <h2 class="text-base font-bold mb-3 text-[var(--text-black-white)] text-left">Who to Follow</h2>
            <div v-for="el in posts?.filter((p) => p?.celebrity === false).slice(0, 4)" :key="el.id"
              class="suggested-wrapper">
              <SuggestedPost :data="el" :type="'user'" :gap="0" :isAuth="!!userData"></SuggestedPost>
            </div>
          </div>
          <!-- <div
            class="bg-[var(--header-bg-light)] border border-[var(--border-leftbar-component)] rounded-2xl px-[10px] py-[10px] shadow-sm flex flex-col gap-2">
            <h2 class="text-base font-bold mb-3 text-[var(--text-black-white)] text-left">Civil Voices</h2>
            <div v-for="el in posts?.filter((p) => p?.celebrity === true).slice(0, 4)" :key="el.id"
              class="suggested-wrapper">
              <SuggestedPost :data="el" :type="'user'" :gap="0" :isAuth="!!userData"></SuggestedPost>
            </div>
          </div> -->
          <div
            class="bg-[var(--header-bg-light)] border border-[var(--border-leftbar-component)] rounded-2xl px-[10px] py-[10px] shadow-sm flex flex-col gap-2 mb-5">
            <h2 class="text-base font-bold mb-3 text-[var(--text-black-white)] text-left">Civil Voices</h2>

            <!-- Check if there are any celebrity users -->
            <template v-if="posts?.filter((p) => p?.celebrity === true).length > 0">
              <div v-for="el in posts?.filter((p) => p?.celebrity === true).slice(0, 4)" :key="el.id"
                class="suggested-wrapper">
                <SuggestedPost :data="el" :type="'user'" :gap="0" :isAuth="!!userData"></SuggestedPost>
              </div>
            </template>

            <!-- Show message if no users found -->
            <div v-else class="text-sm italic text-[var(--text-02)] px-2 py-2">
              No users found
            </div>
          </div>

          <!-- <div
            class="bg-[var(--header-bg-light)] border border-[var(--border-leftbar-component)] rounded-2xl px-[10px] py-[10px] shadow-sm flex flex-col gap-[0.5rem]">
            <h2 class="text-base font-bold mb-3 text-[var(--text-black-white)] text-left">Group Suggestions</h2>
            <div v-for="(group, i) in SuggestedGroups.slice(0, 4)" :key="i"
              class="flex items-start justify-between mb-3 last:mb-0 gap-1">
              <div class="flex items-center gap-1 flex-1 min-w-0">
                <div class="w-8 h-8 rounded-lg flex justify-center items-center text-white text-lg flex-shrink-0"
                  :class="group.color">
                  <img v-if="group.avatarFileId" :is="group.avatarFileId" :src="groupAvatar(group)" alt="group avatar"
                    class="w-10 h-10 rounded-full object-cover group-avatar" />
                  <img v-else src="/images/DefaultAvatar.svg" alt="default avatar"
                    class="w-full h-full rounded-full object-cover" />
                </div>
                <div class="text-wrapper flex-1 min-w-0">
                  <div class="group-name-link truncate cursor-pointer" @click.stop="handleUserClick(group)">{{ group.name }}</div>
                  <p class="text-xs text-[var(--member-text)] text-left">{{ group.members.length }}&nbsp;members</p>
                </div>
              </div>
              <div class="flex-shrink-0" style="width: 62px;">
                <button class="follow-btn" @click.prevent="toggleFollowGroup(group)" :aria-pressed="followingGroupIds.has(group.channelId || group.id)">
                  <span v-if="followingGroupIds.has(group.channelId || group.id)">Unfollow</span>
                  <span v-else>Follow</span>
                </button>
              </div>
            </div>

          </div> -->
        </div><!-- /rightbar__scroll -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch, nextTick, onBeforeUnmount } from 'vue';
// import BaseField from '@/components/ui-kit/BaseField/index.vue';
// import ProgressSpinner from 'primevue/progressspinner';
import { useStore } from 'vuex';
// import CompactPost from '@/components/Post/CompactPost.vue';
import SuggestedPost from '../Post/SuggestedPost.vue';
// import { debounce } from '@/utils/debounce.js';
import { useRouter } from "vue-router";

const store = useStore();
const router = useRouter();

const isUserAuth = computed(() => store.getters.getAuthStatus);

const showProTip = ref(true);
const searchText = computed({
  get: () => store.getters.getSearchText,
  set: value => store.dispatch('updateSearchText', value),
});
const userData = computed(() => store.getters.getAuthUser);
const loading = ref(false);

const getSuggestedPosts = () => store.dispatch('setSuggestedPosts');
// const SuggestedGroups = computed(() => {
//   // Only surface public groups in the Rightbar suggestions.
//   // The orgs store uses `isPrivate` to mark private groups, so
//   // filter those out here.
//   const raw = store.getters.getBrowseOrgs || [];
//   return Array.isArray(raw) ? raw.filter(g => !g.isPrivate) : raw;
// });

const posts = computed(() => {
  const raw = store.getters.getSuggestedPosts;
  let suggestedUsers = [];
  if (Array.isArray(raw)) {
    suggestedUsers = raw;
  } else if (raw && Array.isArray(raw.results)) {
    suggestedUsers = raw.results;
  }

  // Filter out users that are already being followed
  const currentUser = userData.value;
  if (currentUser && currentUser.following && Array.isArray(currentUser.following)) {

    // console.error("Following Users:", currentUser.followin.length);

    const followingIds = new Set(currentUser.following);
    // Also exclude the current user themselves
    followingIds.add(currentUser.id);

    const filteredUsers = suggestedUsers.filter(user => {
      // Exclude followed users and self
      if (followingIds.has(user.id)) return false;

      // Exclude deleted users
      if (user.deletedAt) return false;

      return true;
    });

    // Limit to ~10 final suggestions
    return filteredUsers;
  }

  return suggestedUsers;
});

const displayedUsers = ref([]);
const displayedPosts = ref([]);
const usersOffset = ref(0);
const postsOffset = ref(0);
const pageSize = 10;
const usersLoading = ref(false);
const postsLoading = ref(false);
const allUsers = computed(() => store.getters.getSearchUsers);
const allPosts = computed(() => store.getters.getSearchPosts);
const allGroups = computed(() => store.getters.getSearchGroups || []);
const groupPageSize = 8;
const showMoreGroups = ref(false);
const limitedGroups = computed(() => showMoreGroups.value ? allGroups.value : allGroups.value.slice(0, groupPageSize));
const followingGroupIds = ref(new Set());

// Initialize followingGroupIds from the store's following channels so
// the UI reflects which groups the user already follows.
function initFollowingIds() {
  try {
    // Prefer the authoritative list from the org store, but fall back to
    // the authenticated user's followingChannels (some flows populate the
    // auth user before the org store is initialized).
    let following = store.getters.getFollowingChannels || [];
    if ((!Array.isArray(following) || following.length === 0) && userData && userData.value) {
      // normalize if userData stores followingChannels on the user profile
      following = userData.value.followingChannels || userData.value.following || [];
    }
    // following is an array of { channelId, followType } or simple ids
    const ids = (Array.isArray(following) ? following : []).map(f => (f && (f.channelId || f.id)) || f);
    followingGroupIds.value = new Set(ids.filter(Boolean));
  } catch (e) {
    followingGroupIds.value = new Set();
  }
}

// seed immediately
initFollowingIds();

// also react to changes in store-following list
const storeFollowingChannels = computed(() => store.getters.getFollowingChannels || []);
watch(storeFollowingChannels, () => initFollowingIds());
const isSearchActive = computed(() => !!searchText.value && (allUsers.value.length || allPosts.value.length || allGroups.value.length));

// Accordion state (all closed by default after each search)
const accordion = ref({ people: false, posts: false, groups: false });
const userAccordionInteraction = ref(false);
const accordionBodies = ref({});

// function setAccordionBodyRef(key, el) { if (el) accordionBodies.value[key] = el; }

// const toggleAccordion = (key) => {
//   userAccordionInteraction.value = true;
//   accordion.value[key] = !accordion.value[key];
//   nextTick(() => updateBodyHeight(key));
// };

// Reset all closed when new results arrive
watch([allUsers, allPosts, allGroups, searchText], () => {
  if (!isSearchActive.value) {
    accordion.value = { people: false, posts: false, groups: false };
    userAccordionInteraction.value = false;
    return;
  }
  // On new search results, default closed
  accordion.value = { people: false, posts: false, groups: false };
  userAccordionInteraction.value = false;
  // Heights unnecessary since closed
});

function updateBodyHeight(key) {
  const el = accordionBodies.value[key];
  if (!el) return;
  if (!accordion.value[key]) {
    el.style.maxHeight = '0px';
    el.style.overflow = 'hidden';
    return;
  }
  el.style.maxHeight = 'none';
  // Make content visible while we measure and then constrain axes
  el.style.overflow = 'visible';
  const rect = el.getBoundingClientRect();
  const padding = 16; // space from bottom
  const available = window.innerHeight - rect.top - padding;
  const min = 160; // reasonable minimum
  const target = Math.max(min, available);
  el.style.maxHeight = target + 'px';
  el.style.overflowY = 'auto';
  el.style.overflowX = 'hidden';
}

function updateAllHeights() { Object.keys(accordionBodies.value).forEach(updateBodyHeight); }
function handleResize() { updateAllHeights(); }
onMounted(async () => {
  // Fetch the data on component mount
  await store.dispatch('fetchOtherOrgs');
});
onMounted(() => {
  window.addEventListener('resize', handleResize);
  window.addEventListener('orientationchange', handleResize);
});
onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
  window.removeEventListener('orientationchange', handleResize);
});
// const noSearchResults = computed(() => store.getters.getNoSearchResults);
// const isDevelopment = computed(() => import.meta.env.MODE === 'development');

// // debounce-fetch search results when user types in the Rightbar search
// const fetchSearchResults = debounce(async () => {
//   if (!searchText.value || !searchText.value.trim()) {
//     store.commit('clearSearchResults');
//     resetLists();
//     return;
//   }
//   await store.dispatch('fetchSearchResults', searchText.value);
// }, 600);

watch(searchText, (val) => {
  if (!val || !val.trim()) {
    store.commit('clearSearchResults');
    resetLists();
  }
});

// When search results (users) change, initialize pagination lists
watch(allUsers, (val) => {
  if (searchText.value && searchText.value.trim()) {
    displayedUsers.value = val.slice(0, pageSize);
    usersOffset.value = Math.min(pageSize, val.length);
  }
});

// When search results (posts) change, initialize pagination lists
watch(allPosts, (val) => {
  if (searchText.value && searchText.value.trim()) {
    displayedPosts.value = val.slice(0, pageSize);
    postsOffset.value = Math.min(pageSize, val.length);
  }
});
// const handleUserClick = (item) => {
//   const route = (`/group/${item?.id}`);
//   router.push(route);
// };
const resetLists = () => {
  displayedUsers.value = allUsers.value.slice(0, pageSize);
  displayedPosts.value = allPosts.value.slice(0, pageSize);
  usersOffset.value = pageSize;
  postsOffset.value = pageSize;
};

const loadMoreUsers = () => {
  if (usersOffset.value >= allUsers.value.length || usersLoading.value) return;

  usersLoading.value = true;
  setTimeout(() => {
    const nextUsers = allUsers.value.slice(usersOffset.value, usersOffset.value + pageSize);
    displayedUsers.value = [...displayedUsers.value, ...nextUsers];
    usersOffset.value += pageSize;
    usersLoading.value = false;
  }, 1000);
};

const loadMorePosts = () => {
  if (postsOffset.value >= allPosts.value.length || postsLoading.value) return;

  postsLoading.value = true;
  setTimeout(() => {
    const nextPosts = allPosts.value.slice(postsOffset.value, postsOffset.value + pageSize);
    displayedPosts.value = [...displayedPosts.value, ...nextPosts];
    postsOffset.value += pageSize;
    postsLoading.value = false;
  }, 1000);
};

// const handlePostsScroll = e => {
//   const element = e.target;
//   if (element.scrollTop + element.clientHeight >= element.scrollHeight - 10) {
//     loadMorePosts();
//   }
// };

// const handleUsersScroll = e => {
//   const element = e.target;
//   if (element.scrollTop + element.clientHeight >= element.scrollHeight - 10) {
//     loadMoreUsers();
//   }
// };

onMounted(async () => {
  if (userData.value) {
    loading.value = true;
    await getSuggestedPosts();
    loading.value = false;
  }
});

// const toggleFollowGroup = async (group) => {
//   const channelId = group.channelId || group.id;
//   if (!channelId) return;
//   // Optimistic toggle
//   const isFollowing = followingGroupIds.value.has(channelId);
//   if (isFollowing) {
//     followingGroupIds.value.delete(channelId);
//     await store.dispatch('fetchUnFollowChannel', { channelId });
//   } else {
//     followingGroupIds.value.add(channelId);
//     await store.dispatch('fetchFollowChannel', { channelId, followType: 'follow' });
//   }
// };

// function formatGroupDesc(desc) {
//   if (!desc) return '';
//   const cleaned = desc.replace(/\s+/g, ' ').trim();
//   return cleaned.length > 110 ? cleaned.slice(0, 107) + '…' : cleaned;
// }
// function groupHandle(group) {
//   return group?.username || group?.handle || group?.slug || 'group';
// }
const isDark = ref(false);
function updateScheme() {
  try {
    isDark.value = (document?.documentElement?.getAttribute('scheme') === 'dark');
  } catch (_) {
    isDark.value = false;
  }
}
onMounted(() => {
  updateScheme();
  try {
    const obs = new MutationObserver(updateScheme);
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['scheme'] });
    onBeforeUnmount(() => obs.disconnect());
  } catch (_) { /* no-op */ }
});

function getGroupFallback() {
  return isDark.value ? '/icon/Groupsfill-dark.svg' : '/icon/Groupsfill.svg';
}

// function groupAvatar(group) {
//   return group?.avatarUrl || group?.imageUrl || group?.logoUrl || getGroupFallback();
// }

// function onGroupImgError(e) {
//   try {
//     const fallback = getGroupFallback();
//     const img = e?.target;
//     if (!img) return;
//     // Prevent infinite loop if fallback also fails
//     if (img.dataset.fallbackApplied === '1') return;
//     img.src = fallback;
//     img.dataset.fallbackApplied = '1';
//   } catch (_) {
//     // no-op
//   }
// }

// Reset follow cache when group search results change (keeps optimistic model simple)
watch(allGroups, () => {
  // when available groups change, re-sync following ids from store
  initFollowingIds();
});

// If auth status changes (login), fetch suggested posts automatically
watch(isUserAuth, async (val) => {
  if (val) {
    loading.value = true;
    await getSuggestedPosts();
    loading.value = false;
  }
});

// Also watch userData in case auth status isn't set but user data appears
watch(userData, async (val) => {
  if (val) {
    // Ensure following ids are synced from auth user when user data becomes available
    initFollowingIds();
    loading.value = true;
    await getSuggestedPosts();
    loading.value = false;
  }
});

</script>

<style lang="scss">
.text-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.pro-tip {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}

.scroll-box {
  overflow-y: scroll;
  /* enables scroll functionality */
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* Internet Explorer and Edge */
}

.scroll-box::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}

.rightbar {
  /* Offset variables for alignment; adjust here if needed */
  --rb-left-shift: 7px;
  /* left shift for search/accordions (aligned with search field) */
  --rb-right-extend: -54px;
  /* extend 12px more to the right */
  --rb-accordion-left: var(--rb-left-shift);
  --rb-accordion-right: 0px;
  /* no extension past rightbar boundary */
  --rb-divider-inset: 60px;
  /* divider start after avatar */
  --rb-search-extra-right: 16px;
  /* additional right-side width for search (4px more) */
  // Use full available width within the layout constraints
  width: 100%;
  min-width: 200px;
  /* Minimum usable width */
  text-align: center;
  font-size: 14px;
  position: relative; // Use relative positioning
  overflow-x: hidden;
  /* Prevent horizontal overflow */

  // Ensure all rightbar content respects width constraints
  * {
    max-width: 100%;
    box-sizing: border-box;
  }

  &__inner {
    // padding: 16px 16px 16px 8px; // minimal left padding for visual separation from centerbar
    position: sticky; // Use sticky positioning
    top: 0; // Default layout already adds padding-top equal to header height
    width: 100%;
    /* Use full container width */
    margin-left: 0;
    will-change: auto;
    isolation: isolate;
    display: flex;
    flex-direction: column;
    height: calc(100vh - var(--header-height, 80px) - 20px);
    max-height: calc(100vh - var(--header-height, 80px) - 20px);
    overflow: hidden;
    /* prevent outer scroll */
    z-index: 10;
    background: transparent;
    /* Remove background to show page background */
    border-radius: 0;
    /* Remove rounded corners */
    backdrop-filter: none;
    /* Remove blur effect */

    // Dark theme variant
    [scheme='dark'] & {
      background: transparent;
      /* Remove dark theme background */
    }

    // Simplified responsive padding - no more complex transforms
    @include _1279 {
      // padding: 16px 16px 16px 16px; // Simplified padding
    }

    @include _1024 {
      // padding: 20px 36px 20px 16px;
      // margin-left: 0; // Reset on mobile when rightbar is hidden anyway
    }

    @include _767 {
      padding: 20px 32px 20px 16px;
    }

    @include _639 {
      padding: 20px 16px 20px 8px;
    }

    &__panel {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      background: transparent;
      /* Remove background to show page background */
      border: none;
      /* Remove border */
      border-radius: 0;
      /* Remove border radius */
      padding: 16px 0 18px; // Remove horizontal padding to let search bar span full width
      box-shadow: none;
      /* Remove shadow */
      gap: 12px;
      overflow-y: auto;
      position: relative;
    }

    [scheme='dark'] &__panel {
      background: transparent;
      /* Remove dark theme background */
      box-shadow: none;
      /* Remove dark theme shadow */
      border: none;
      /* Remove dark theme border */
    }

    &__scroll {
      // flex: 1 1 auto;
      // padding: 0 14px; // Add horizontal padding to content area
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      overflow-y: auto;
      overflow-x: hidden; // prevent horizontal scroll if search extends right
    }

    // Search placement and sizing
    &__search {
      margin-bottom: 10px;
    }

    &__search-input {
      display: block;
      width: 100%; // fill the same inner content width as the Suggested block
    }

    // Removed search input styles (search UI reverted)

    // Clean component styling
    .post__username {
      max-width: none; // Remove arbitrary constraints
    }

    .rightbar__posts-list {
      width: 100%;
    }
  }

  &__posts {
    margin-top: 0;
    border-radius: 10px;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    overflow: visible;
    /* allow content to scroll within panel */

    @include _1024 {
      max-height: unset;
      max-width: 100%;
      margin: 20px auto 0;
    }

    &-list {
      background: var(--app-card-bg);
      border-radius: 10px;
      padding: 0; // flush content left
      width: 100%;
      // Allow independent scroll for search results (users/posts/groups)
      max-height: 360px;
      overflow-y: auto;
      overflow-x: hidden;
      scrollbar-width: thin;
      scrollbar-color: var(--surface-border, var(--border-primary)) transparent;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: var(--surface-border, var(--border-primary));
        border-radius: 3px;
      }

      .grow {
        max-width: 100%;
      }
    }
  }

  &__title {
    font-family: 'ClashDisplay-Semibold';
    line-height: 150%;
    color: var(--foreground-primary) !important;
  }

  &__suggested-block {
    background: var(--app-card-bg);
    border: 1px solid var(--surface-border, var(--border-primary));
    padding: 2px 0 4px 0; // compact vertical padding for stacked result blocks
    border-radius: 16px;
    /* Enable container queries for children (e.g., SuggestedPost) */
    container-type: inline-size;
    container-name: suggested-block;
    box-shadow: var(--surface-shadow-sm, 0 2px 4px -2px rgba(0, 0, 0, 0.06)), 0 1px 2px rgba(0, 0, 0, 0.04);
    backdrop-filter: blur(4px); // subtle frosted look on light backgrounds
    position: relative;
    max-height: 340px;
    /* default (non-search mode) */
    overflow-y: auto;
    /* default (non-search mode) */
    overflow-x: hidden;
    /* Prevent horizontal scrolling */
    margin-left: 7px;
    /* Adjusted shift: now 7px to the right */

    /* Hide scrollbars */
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */

    &::-webkit-scrollbar {
      display: none;
      /* Chrome, Safari and Opera */
    }
  }

  .suggested-wrapper {
    position: relative;
    padding: 10px 0px 8px 0px; // more comfortable vertical rhythm
    margin: 0; // remove side inset, align to container edge
    border-radius: 10px;
    transition: background .16s ease, box-shadow .16s ease;
    outline: none;

    // Divider line (skip last) starting after avatar column (~46px avatar + gap)
    &:not(:last-child)::after {
      content: '';
      position: absolute;
      left: var(--rb-divider-inset); // aligns after avatar to reduce visual noise
      right: 8px;
      bottom: 0;
      height: 1px;
      background: linear-gradient(to right, transparent, var(--surface-border, var(--post-border)) 30%, var(--surface-border, var(--post-border)) 70%, transparent);
      opacity: .55;
      pointer-events: none;
    }

    // Hover / focus states
    // &:hover {
    //   background: var(--app-card-bg-hover);
    // }

    &:focus-visible {
      background: var(--app-card-bg-hover);
      box-shadow: 0 0 0 2px var(--glow-color, rgba(59, 130, 246, 0.25));
    }

    // Provide a subtle pressed feedback
    // &:active {
    //   background: var(--hover-filter-tags-bg, rgba(0, 0, 0, 0.04));
    // }
  }

  // Dark theme tuning
  [scheme='dark'] .suggested-wrapper {
    &:not(:last-child)::after {
      opacity: .35;
    }

    &:hover {
      background: var(--app-card-bg-hover);
    }

    &:active {
      background: var(--app-card-bg-hover);
    }
  }

  .suggested-card {
    background: var(--app-card-bg);
    border: 1px solid var(--surface-border, var(--border-primary));
    border-radius: 10px;
    padding: 10px 12px;
    transition: background .18s ease, box-shadow .18s ease, border-color .18s ease;
    display: block;
    position: relative;

    &:hover {
      background: var(--app-card-bg-hover);
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
    }
  }

  [scheme='dark'] &__suggested-block {
    background: var(--app-card-bg);
    border-color: var(--surface-border, #2b3440);
    box-shadow: 0 2px 6px -2px rgba(0, 0, 0, 0.65), 0 1px 2px rgba(0, 0, 0, 0.4);
  }

  [scheme='dark'] .suggested-card {
    background: var(--app-card-bg);
    border-color: var(--surface-border, #2d3743);

    &:hover {
      background: var(--app-card-bg-hover);
    }
  }

  // Mobile responsiveness
  @include _1024 {
    width: 100%;
    max-width: 100%;
  }

  @include _767 {
    position: relative;
    top: 0;
  }
}

/* Accordion styles */
.accordion-results {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.accordion-section {
  border: 1px solid var(--surface-border, var(--border-primary));
  border-radius: 14px;
  background: var(--app-card-bg);
  overflow: hidden;
}

.accordion-header {
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--foreground-primary);
}

.accordion-header:hover {
  background: var(--app-card-bg-hover);
}

.accordion-body {
  padding: 4px 0 10px 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height .25s ease;
}

.chevron {
  display: inline-block;
  transform: rotate(90deg);
  transition: transform .25s ease;
  opacity: .65;
}

.chevron.open {
  transform: rotate(270deg);
  opacity: 1;
}

// Removed search-mode accordion visual tweaks
.rightbar__posts-list.slim {
  max-height: 300px;
  overflow-y: auto;
  /* Hide scrollbars while keeping scroll functionality */
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */
}

.rightbar__posts-list.slim::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}

/* When accordion bodies become scrollable, also hide their scrollbars */
.accordion-body {
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */
}

.accordion-body::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}

/* Transition */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all .22s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

// Removed search-mode scroll overrides (revert to independent list scrolling)

/* Removed flush-left overrides inside accordion to restore original spacing */

/* Align search result blocks (People, Posts, Groups) with the search field edges */
.accordion-results {
  .accordion-section {
    margin-left: var(--rb-accordion-left) !important;
    /* shift whole section (header + list) to the right */
    margin-right: var(--rb-accordion-right) !important;
    /* extend section (header area) to the right */
  }

  .rightbar__posts-list.rightbar__suggested-block {
    /* Inside accordion: items should butt against the left border */
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 0 !important;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  /* Remove inner wrapper insets so content aligns flush */
  .suggested-wrapper {
    margin-left: 0 !important;
    padding-left: 0 !important;
  }

  .group-wrapper {
    margin-left: 0 !important;
    padding-left: 0 !important;
  }

  .group-wrapper:not(:last-child)::after {
    left: var(--rb-divider-inset) !important;
  }

  .people-list {
    margin-left: 0 !important;
  }
}

/* Group results styling aligned to people list */
.groups-list {
  padding-top: 0;
}

.group-wrapper {
  padding: 10px 14px 12px 14px;
}

.group-wrapper:not(:last-child)::after {
  content: '';
  position: absolute;
  left: 60px;
  right: 8px;
  bottom: 0;
  height: 1px;
  background: linear-gradient(to right, transparent, var(--surface-border, var(--post-border)) 30%, var(--surface-border, var(--post-border)) 70%, transparent);
  opacity: .55;
}

[scheme='dark'] .group-wrapper:not(:last-child)::after {
  opacity: .35;
}

.group-name-link {
  font-weight: 600;
  font-size: 13px;
  line-height: 1.3;
  color: var(--foreground-primary);
  text-decoration: none;
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.group-name-link:hover {
  text-decoration: underline;
}

.group-username {
  font-size: 12px;
  opacity: .75;
  line-height: 1.2;
  margin-top: 2px;
}

.group-desc {
  font-size: 12px;
  line-height: 1.35;
  margin-top: 4px;
  color: var(--foreground-secondary, var(--foreground-primary));
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.follow-btn {
  flex-shrink: 0;
  align-self: center;
  font-size: 0.8rem;
  font-weight: 500;
  font-family: 'SFProText', serif;
  padding: 9px 0px;
  border-radius: 9px;
  border: none;
  // background: var(--interactive-01, #a3e635);
  background-color: var(--joine-button);
  // color: var(--button-on-primary, #000);
  color: white;
  line-height: 1;
  cursor: pointer;
  transition: background .2s ease, transform .15s ease;
  box-shadow: var(--button-shadow, 0 1px 2px rgba(0, 0, 0, 0.08));
  font-weight: 600;
  line-height: 1;
  width: 70%;
  max-width: 78px;
  min-width: 60px;
  white-space: nowrap;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.follow-btn:hover {
  // background: var(--interactive-01-hover, #95d130);
  background-color: var(--joine-button);
}

.follow-btn:active {
  background: var(--interactive-01-active, #95d130);
  transform: translateY(1px);
}

// [scheme='dark'] .follow-btn {
//   background: var(--interactive-01, #a3e635);
//   color: var(--button-on-primary, #000);
// }

// [scheme='dark'] .follow-btn:hover {
//   background: var(--interactive-01-hover, #95d130);
// }

.follow-btn span {
  display: inline-block;
}

.follow-btn:focus-visible {
  outline: 2px solid var(--focus-ring, rgba(59, 130, 246, 0.55));
  outline-offset: 2px;
}

.follow-btn:not(:disabled).is-following {
  background: var(--interactive-01, #a3e635);
}

.show-more-wrapper {
  text-align: center;
  margin: 6px 0 2px;
}

.show-more-btn {
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 14px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  color: var(--foreground-primary);
}

.show-more-btn:hover {
  text-decoration: underline;
}

/* Light theme visibility adjustments for groups */
[scheme='light'] .group-name-link {
  color: var(--foreground-primary, #111);
}

[scheme='light'] .group-username {
  color: #555;
  opacity: .85;
}

[scheme='light'] .group-desc {
  color: #5a5a5a;
}

[scheme='light'] .group-wrapper:hover {
  background: var(--app-card-bg-hover);
}

/* Avatar border + unified fill */
.group-avatar {
  border: 1px solid var(--surface-border, #d0d7de);
  background: var(--app-card-bg);
}

[scheme='dark'] .group-avatar {
  border-color: var(--surface-border, #2d3743);
  background: var(--app-card-bg);
}
</style>

<style scoped>
.rightbar__search,
.rightbar__suggested-block {
  /* Reduce width by 16px, keep left edge the same */
  width: calc(100% - 16px) !important;
  /* If you have a max-width set elsewhere, also reduce it by 16px */
  max-width: calc(100% - 16px) !important;
}

.accordion-results .accordion-section {
  /* Ensure accordion sections stay within rightbar bounds */
  width: calc(100% - var(--rb-accordion-left)) !important;
  max-width: calc(100% - var(--rb-accordion-left)) !important;
  box-sizing: border-box;
}
</style>
